/* eslint-disable arrow-body-style */
/* eslint-disable eqeqeq */
import { LoadingButton } from '@mui/lab';
import { Stack } from '@mui/material';
import { FormProvider, RHFEditor } from 'src/components/hook-form';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { TextItemDefaultValues, TextItemSchema } from './components/sectionItemsSchemas';
import { useEffect } from 'react';
import { AssetsSection } from './components/AssetsSection';

import { Item, ItemTypesEnum, TextItem } from 'src/@types/Course';
import TextMaxLine from 'src/components/TextMaxLine';
import DetailsSection from './components/DetailsSection';
import { StyledFormBox } from './components/styles';
// ----------------------------------------------------------------------

export default function TextItemForm({
  onSubmit,
  currentItem,
}: {
  onSubmit(data: Item): void;
  currentItem: Item | undefined;
}) {
  const methods = useForm({
    resolver: yupResolver(TextItemSchema),
    defaultValues: TextItemDefaultValues,
  });
  const {
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { isSubmitting },
  } = methods;
  const values = watch();
  const updateDefaultValues = () => {
    return {
      assets: currentItem?.assets || [],
      title: currentItem?.title || '',
      title_ar: currentItem?.title_ar || '',
      details:
        currentItem?.details ??
        ({
          type: ItemTypesEnum.TEXT,
        } as TextItem),
      isFreeToWatch: currentItem?.isFreeToWatch || false,
      description: currentItem?.description || '',
      description_ar: currentItem?.description_ar || '',
      body_ar: (currentItem?.details as TextItem).body_ar ?? '',
      order: currentItem?.order || 0,
      duration: currentItem?.duration || 0,
      points: currentItem?.points || 1,
      body: (currentItem?.details as TextItem).body ?? '',
    } as Item;
  };
  useEffect(() => {
    if (currentItem) {
      reset(updateDefaultValues());
    }
    if (!currentItem) {
      reset(TextItemDefaultValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItem]);

  return (
    <Stack height={'100%'} sx={{ overflow: 'auto' }}>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack direction={'column'} justifyContent={'space-between'} height={'100%'}>
          <StyledFormBox
            sx={{
              gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
            }}
          >
            <DetailsSection
              isFree={values.isFreeToWatch}
              setIsFree={(val) => {
                setValue('isFreeToWatch', val);
              }}
            />{' '}
            <TextMaxLine
              sx={{
                fontSize: '18px',
                paddingBottom: '10px',
                fontWeight: '700',
              }}
            >
             English body
            </TextMaxLine>
            <RHFEditor name="body" />
            <TextMaxLine
              sx={{
                fontSize: '18px',
                paddingBottom: '10px',
                fontWeight: '700',
              }}
            >
             Arabic body
            </TextMaxLine>
            <RHFEditor name="body_ar" />
            <AssetsSection assets={values?.assets ?? []} setValue={setValue} />
          </StyledFormBox>
          <Stack alignItems="flex-end" sx={{ mt: 3 }}>
            <LoadingButton
              style={{ width: '200px', height: '50px' }}
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              {'Save '}
            </LoadingButton>
          </Stack>
        </Stack>
      </FormProvider>
    </Stack>
  );
}
